import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import CreateBooking from '../components/CreateBooking';
import { createStructuredSelector } from 'reselect';
import {
  roomTypeSelector,
  selectedRoomSelector
} from 'routes/ChooseAccommodation/selectors';
import { setShouldRefetch } from 'routes/ChooseAccommodation/reducer';
import {
  endDateSelector,
  isAdminSelector,
  numberOfGuestsSelector,
  propertySelector,
  selectedOffersSelector,
  startDateSelector,
  submittedAccountSelector,
  secondSubmittedAccountSelector,
  isWaitListBookingSelector,
  waitListBookingReasonSelector,
  waitListBookingCommentSelector
} from 'routes/DateSelection/selectors';
import {
  bookingCommentsSelector,
  bookingSourceSelector
} from 'routes/selectors';
import {
  guestInfoSelector,
  reviewAndSubmitFormSelector
} from 'routes/ReviewAndSubmit/selectors';
import { getBookingEnginePath } from 'utils/routeUtils';
import { bookingSuccess } from 'routes/Confirmation/reducer';

const mapStateToProps = createStructuredSelector({
  roomType: roomTypeSelector,
  selectedRoom: selectedRoomSelector,
  numberOfGuests: numberOfGuestsSelector,
  startDate: startDateSelector,
  endDate: endDateSelector,
  property: propertySelector,
  guestInfo: guestInfoSelector,
  submittedAccount: submittedAccountSelector,
  selectedOffers: selectedOffersSelector,
  isAdmin: isAdminSelector,
  bookingSource: bookingSourceSelector,
  reviewAndSubmitForm: reviewAndSubmitFormSelector,
  bookingComments: bookingCommentsSelector,
  secondSubmittedAccount: secondSubmittedAccountSelector,
  isWaitListBooking: isWaitListBookingSelector,
  waitListBookingReason: waitListBookingReasonSelector,
  waitListBookingComment: waitListBookingCommentSelector
});

function mapDispatchToProps(dispatch) {
  return {
    goToConfirmationPage: reservationData => {
      dispatch(bookingSuccess(reservationData.hotelReservation));
      return dispatch(
        push(
          getBookingEnginePath(
            `confirmation/${reservationData.hotelReservation.id}`
          )
        )
      );
    },
    goToWaitlistConfirmationPage: () =>
      dispatch(push(getBookingEnginePath('confirmation'))),
    setShouldRefetch: shouldRefetch => dispatch(setShouldRefetch(shouldRefetch))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateBooking);
